import { render, staticRenderFns } from "./BvaAdList.vue?vue&type=template&id=1f4bdf53&"
import script from "./BvaAdList.vue?vue&type=script&lang=ts&"
export * from "./BvaAdList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports